/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_2_DInputs */

const en_cp_cal_2_d = /** @type {(inputs: Cp_Cal_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview 5 users, write the PRD in the wizard, revise with Bystep Agent.`)
};

const id_cp_cal_2_d = /** @type {(inputs: Cp_Cal_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wawancara 5 pengguna, tulis PRD lewat wizard, revisi dengan Bystep Agent.`)
};

/**
* | output |
* | --- |
* | "Interview 5 users, write the PRD in the wizard, revise with Bystep Agent." |
*
* @param {Cp_Cal_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_2_d = /** @type {((inputs?: Cp_Cal_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_2_d(inputs)
	return en_cp_cal_2_d(inputs)
});